import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { WindowRef } from '@spartacus/core';
import { NavigationUIComponent } from '@spartacus/storefront';

@Component({
  selector: 'dp-footer-navigation-ui',
  templateUrl: './footer-navigation-ui.component.html',
  styleUrls: ['./footer-navigation-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DpFooterNavigationUiComponent extends NavigationUIComponent {
  readonly #winRef = inject(WindowRef);

  nodeClicked(nodeJavascript: string): void {
    if (!nodeJavascript) {
      return;
    }

    const button = this.#winRef.document.createElement('button');
    // eslint-disable-next-line no-eval
    button.onclick = (): void => eval(nodeJavascript);
    this.#winRef.document.body.appendChild(button);
    button.click();
    button.remove();
  }
}
